import { render, staticRenderFns } from "./SicnAddDialog.vue?vue&type=template&id=ddb990e6&scoped=true"
import script from "./SicnAddDialog.vue?vue&type=script&lang=js"
export * from "./SicnAddDialog.vue?vue&type=script&lang=js"
import style0 from "./SicnAddDialog.vue?vue&type=style&index=0&id=ddb990e6&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb990e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddb990e6')) {
      api.createRecord('ddb990e6', component.options)
    } else {
      api.reload('ddb990e6', component.options)
    }
    module.hot.accept("./SicnAddDialog.vue?vue&type=template&id=ddb990e6&scoped=true", function () {
      api.rerender('ddb990e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/components/SicnAddDialog.vue"
export default component.exports